import { render, staticRenderFns } from "./Daphne.vue?vue&type=template&id=4fd22347&scoped=true&"
import script from "./Daphne.vue?vue&type=script&lang=js&"
export * from "./Daphne.vue?vue&type=script&lang=js&"
import style0 from "./Daphne.vue?vue&type=style&index=0&id=4fd22347&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd22347",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
